import * as React from "react";
import { Authorize } from "reauthorize";

import { SraCustomerDetailModel } from "../model";
import { ADMIN_ROLES } from "../../../auth";

import { DeactivateSraCustomerButton } from "./DeactivateSraCustomerButton";
import { ActivateSraCustomerButton } from "./ActivateSraCustomerButton";

export const ToggleSraCustomerActiveButton: React.FunctionComponent<{ sraCustomer: SraCustomerDetailModel }> = (props) => {
    return (
        <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
            {props.sraCustomer.active ?
                <DeactivateSraCustomerButton sraCustomerId={props.sraCustomer.id} /> :
                <ActivateSraCustomerButton sraCustomerId={props.sraCustomer.id} />}
        </Authorize>
    );
};
